export default "__VITE_ASSET__bfc78742__"